import styled from 'styled-components'

const StyledScreen = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  user-select: none;
`

export default StyledScreen



// WEBPACK FOOTER //
// ./src/components/StyledScreen.js